'use strict';

class ClosedAccount {
  constructor(billingService) {
    this.billingService = billingService;
  }

  $onInit() {
    this.salesLedger = {};
    this.unpaid = {};
    this.all = {};
    this.dcCases = {};
    this.vippsOrders = {};

    this.billingService.getUnpaidInvoices()
      .then((resp) => {
        this.unpaid = resp.data;
      });

    this.billingService.getVippsOrders()
      .then((resp) => {
        this.vippsOrders = resp.data;
      });

    this.billingService.getDcCases()
      .then((resp) => {
      this.dcCases = resp.data;
  });

    this.billingService.getAllInvoices()
      .then((resp) => {
        this.all = resp.data;
      });

    this.billingService.getSalesLedger()
      .then((resp) => {
        this.salesLedger = resp.data;
      });
  }
}

ClosedAccount.$inject = ['billingService'];

const closedAccount = {
  controller: ClosedAccount,
  template: `
    <h2>Stengt for manglende betaling</h2>
    <alert data="{ type: 'error', message: 'Denne kontoen er midlertidig stengt grunnet manglende betaling for bruk av SendRegning.' }" />

    <section ng-show="$ctrl.dcCases !== null && $ctrl.dcCases.length > 0">
      <h2>Ubetalte regninger har blitt sendt til inkasso</h2>
      <h4>Disse regningene har blitt sendt til inkasso. Inkassobyrået skal ha sendt betalingsoppfordring. Ved spørsmål, kontakt Collectia på <a href = "mailto: kundesenter@collectiagroup.no">kundesenter@collectiagroup.no</a> eller Intrum på <a href = "mailto: hjelp@intrum.no">hjelp@intrum.no</a>.</h4>

      <table class="small">
      <thead>
        <tr>
            <th>Regning</th>
            <th>Dato</th>
            <th>Forfallsdato</th>
            <th>Saksnummer</th>
            <th>Overført</th>
            <th>Inkassobyrå</th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="entry in $ctrl.dcCases track by $index">
          <td><a href="{{ entry.link }}" >{{ entry.invoiceNo}}</a></td>
          <td>{{ entry.invoiceDate}}</td>
          <td>{{ entry.dueDate}}</td>
          <td>{{ entry.caseNumber}}</td>
          <td>{{ entry.transferDate}}</td>
          <td>{{ entry.collectionAgency === 'BEWA' ? 'COLLECTIA' : 'INTRUM'}}</td>
        </tr>
     </table>
    </section>

    <br/><br/>
    <section ng-show="$ctrl.unpaid.paymentDetails !== null">
      <billing-table title="'Ubetalte regninger for bruk av SendRegning'" header="'Disse regningene har forfalt, men har ikke blitt sendt til inkasso. De kan betales til SendRegning som normalt.'" items="$ctrl.unpaid.items" summary="$ctrl.unpaid.summary"></billing-table>

      <h3 class="subheader">Betalingsdetaljer</h3>
      <ul class="no-bullet">
        <li ng-if="$ctrl.unpaid.paymentDetails.balance !== 0"><b>Betalt p&aring; andre fakturaer:</b> {{ $ctrl.unpaid.paymentDetails.balance | crowns }}</li>
        <li><b>&Aring; betale:</b> {{ $ctrl.unpaid.paymentDetails.total | crowns }}</li>
        <li><b>KID:</b> {{ $ctrl.unpaid.paymentDetails.kid }}</li>
        <li><b>Konto:</b> {{ $ctrl.unpaid.paymentDetails.accountNumber | accountNumberFormat }}</li>
      </ul>
    </section>


    <claim-payment />

    <button class="button secondary" ng-show="$ctrl.all.items.length" ng-click="showAll = true; showSl = false">Se alle regninger</button>
    <button class="button secondary" ng-show="$ctrl.salesLedger.items.length" ng-click="showAll = false; showSl = true">Se kontoutskrift</button>
    <button class="button secondary" ng-show="$ctrl.vippsOrders.length" ng-click="showAll = false; showSl = false; showVipps = true">Se Vipps betalinger</button>

    <billing-table ng-show="showAll" title="'Regninger for bruk av SendRegning'" items="$ctrl.all.items" summary="$ctrl.all.summary"></billing-table>
    <billing-sales-ledger ng-show="showSl" items="$ctrl.salesLedger.items" total="$ctrl.salesLedger.total"></billing-sales-ledger>

        <div ng-show="showVipps">
      <table>
        <thead>
          <tr>
            <th>Regning</th>
            <th>Dato</th>
            <th>Beløp</th>
            <th>OrdreId</th>
            <th>Mobilnummber</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="item in $ctrl.vippsOrders" ng-switch="item.status">
            <td>
              <a href="{{ item.download }}">{{ item.invoiceNo }}</a>
            </td>
            <td>{{ item.createTs }}</td>
            <td>{{ item.amount }}</td>
            <td>{{ item.vippsOrderId }}</td>
            <td>{{ item.mobile }}</td>
            <td ng-switch-when="CAPTURED" class="center-align"><span data-balloon="{{ item.status }}"><i class="fa fa-check" style="color: #0f4b1c;"></i></span></td>
            <td ng-switch-default class="center-align"><span data-balloon="{{ item.status }}"><i class="fa fa-times" style="color: #970b0e;"></i></span></td>

          </tr>
        </tbody>
      </table>
    </div>
  `
};

angular
  .module('SendRegning')
  .component('closedAccount', closedAccount)
  .config(($routeProvider) => {
    $routeProvider
      .when('/feil/stengt', {
        title: 'Stengt for manglende betaling',
        template: '<closed-account/>',
        noSidebar: true,
        noNav: true,
        secure: true
      });
  });
